import amountToFixed from "./amountToFixed";
import { parseAmount } from "./parseAmount";

export const truncateString = (str, num) => {
    if (typeof str !== 'string' || num <= 3) {
        return typeof str === 'string' ? str.slice(0, num) : '';
    }
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num - 3) + '...';
};

export const formatCurrency = (amount,amountPrefix = "RD", currencySymbol = '$') => {
    return `${amountPrefix}${currencySymbol}${amountToFixed(parseAmount(amount), 2)}`;
}